/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Rxjs imports.
 */
import { Subject, Subscription, timer as observableTimer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Service imports.
 */
import { GetwebService } from '../../dataservices/web/getweb.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { AuthService } from '../../auth/auth.service';
import { LocalstorageService } from '../../auth/localstorage.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { GetService } from './../../dataservices/get.service';
import { SqsdataService } from '../../dataservices/sqsdata.service';
import { DocquityAnalyticsService } from './../../dataservices/docquity-analytics/docquity-analytics.service';
import { EncryptionService } from './../../auth/encryption.service';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';

/**
 * Modal imports.
 */
import { UserProfileRoot } from '../../interface/userprofile/userprofile';
import { CommunityConfirmation, ConfirmationModalData, GrCommunity, PostedIn, userComment } from '../../onboarding/interface/global.model';

/**
 * Directive imports.
 */
import { ButtonDirective } from '../../directives/ga.directive';

/**
 * Environment imports.
 */
import { environment } from '../../../environments/environment';

let id = 0;

/**
 * Import constants.
 */
import { MEDIA_TYPE, NUMBERS, GRADIENT_DIRECTION, COMMENT_LIST_TYPE, COMMUNITY_PRIVACY, COMMUNITY_REGEX, COMMUNITY_JOIN_TYPE, ERROR_CODES, REPOST_STATUS, PRODUCT_TYPE_CONSTANT, SCREEN_NAME, REPOST_TYPE_ITEM, STORY_CREATION_TYPE, CREATE_STORY_TYPES, TEMPLATE_TYPE, USER_STORY_NUDGE, STATUS_CODE,ACTION_ON,CTA_TYPE,ACTION_TYPE, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING } from './../../constants/app.constants';
import { FEED_DETAIL } from './../../constants/data-testId.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { DETAIL_ENTRY, DETAIL_EXIT, CLICK, CLICK_SUB, LIKE } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { SearchCmeCardComponent } from 'src/app/search/search-card/search-cme-card/search-cme-card.component';

/**
 * Web Feed Detail Component
 */
@Component({
  selector: 'app-web-feed-detail',
  templateUrl: './web-feed-detail.component.html',
  styleUrls: ['./web-feed-detail.component.scss']
})
export class WebFeedDetailComponent implements OnInit, OnChanges, OnDestroy {
  /**
  *
  * Gradient direction constant
  * @memberof WebFeedDetailComponent
  */
  public gradientDirection = GRADIENT_DIRECTION;
  /**
   * User comment object.
   */
  public emitUserComment: userComment;
  /**
   * Screen name.
   */
  public feedDetailScreen = SCREEN_NAME.FEED_DETAIL;

  /**
   * Store the name for the data test id.
   */
  public dataTestId = FEED_DETAIL;
  /**
   * Product type constant.
   */
  public productTypeConstant = PRODUCT_TYPE_CONSTANT;
  /**
   * Create repost screen
   */
  public createRepostScreen = SCREEN_NAME.CREATE_REPOST;
  /**
   * Emit repost data.
   */
  @Output() emitRepostData = new EventEmitter();
  @Output() resetFeedDetailModal = new EventEmitter();
  @Input() feedDetailModal;
  @Input() mediaIdx;
  @Input() feedIdx;
  @Input() feedId;
  @Input() ecId?:number;


  @Input() isModal = false;
  /**
   * posted click event
   */
  @Input() isPostedEvent?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feedObject: any;
  public feed_detail_api_in_process = false;
  public pdfSrc = './assets/sample.pdf';
  public see_more = false;
  public screen_name: string;
  public commentObj; // Comment Component Object
  public showComment = false;
  public showLikeListModal = false;
  public feed_like_loader = false;
  public feed_bookmark_loader = false;
  public bookmarkObj;
  public suggestionObj;
  public is_bookmark = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public channelDetail: any;
  public useractivity = false;
  public loginUserCustomeId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public likeObj: any;
  public userProfileData: UserProfileRoot;
  public keyboard = false;
  public page_from = this.mls.googleEventText.feed_detail.category;
  public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  public tooltip_data = [];
  public screenName = SCREEN_NAME.FEED_DETAIL;
  /**
   * Output is used to emit feed post specialty from detail.
   */
  @Output() feedSpecialty = new EventEmitter();
/**
 * used to show error message
 */
  public error_msg: string;

  /**
   * AWS SQS Credentials
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public SQSCredentials: any;
  /**
   * Used to store last sqs data.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public lastSQSData: any;
  /**
   * Used to get language
   */
  public lang: string;
  /**
   * Used to set timezone
   */
  public timeZoneOffset: string;
  /**
   * Identify type of product.
   */
  public productType: number;
  /**
   * Key used to get available media types.
   */
  public mediaType = MEDIA_TYPE;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * check if slide is called
   */
  private isSlideChanging = false;
  /**
   * Key used to get comment list type.
   */
  public commentListType = COMMENT_LIST_TYPE;

  /**
   * number constant
   */
  public numbers = NUMBERS;
  /**
   * flag to show posted in details
   */
  public showPostedIn = false;
  /**
   * @notifier$ defines a notifier subject stream to end data streaming.
   */
  private notifier$ = new Subject();

  public confirmedCommunity: CommunityConfirmation;
  public confirmationModal = false;
  public confirmationText: ConfirmationModalData;
  public withdrawRequest: CommunityConfirmation;
  public userId: string;
  /**
   * Used to set timezone string
   */
  public getTimeZoneString(): string {
    return new Date().toTimeString().slice(9);
  }
  /**
   * repost meta flag
   */
  public isMetaGenerated = false;

  public startTime;

  /**
   * Necessary instances.
   */
  constructor(
    public igs: ImageGroupService,
    public dss: DataStorageService,
    private gws: GetwebService,
    public ems: EventMsgService,
    public multiLangService: MultiLangService,
    private masterService: MasterserviceService,
    private authService: AuthService,
    private localStorage: LocalstorageService,
    private jwtSer: JwtDecodeService,
    private postSer: PostApiService,
    public fcs: FunCollectionService,
    public mls: NewLanguageService,
    private directive_ser: ButtonDirective,
    private getApiService: GetService,
    private sqsdataService: SqsdataService,
    private docAnalyticsService: DocquityAnalyticsService,
    private encrypt: EncryptionService,
    private router: Router,
    private analyticsEventService: AnalyticsEventService,
    private analyticSdk: Analytics
  ) {

    const d = new Date();
    this.fcs.sessiontime.start_time = d.getTime().toString(); sessionStorage.setItem('sessionstarttime', this.fcs.sessiontime.start_time);

    environment.ideal_state.current_page = this.page_from;


    this.subscriptions.add(this.dss.feedDetailChanged.subscribe(data => {
      if (data.type == 'feed') {
        this.feedId = data.id;
        id = this.feedId;
        this.mediaIdx = 0;
        this.feedIdx = 0;
        this.feedObject = null;
        this.getFeedDetail();

      }
    }));
  }

  /**
   * ngOnInit.
   */
  ngOnInit(): void {
    /**
     * Used to get timezone string
     * 
     */
    this.timeZoneOffset = this.getTimeZoneString();
    /**
     * Used to get language
     */
    if (localStorage.getItem('lang') !== null) {
      this.lang = localStorage.getItem('lang');
    }

    this.checkUserIdealState();
    this.fcs.IsUserActiveOnApp(this.page_from);
    this.subscriptions.add(this.dss.is_browser_tab_active_action.subscribe(data => {
      if (data.page_from == this.page_from && data.is_visible == 0) {
        if (sessionStorage.getItem('sessionstarttime') != null) {
          this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
        }
        const d = new Date();
        this.fcs.sessiontime.end_time = d.getTime().toString();
        environment.ideal_state.is_ideal_state = true;
      } else if (data.page_from == this.page_from && data.is_visible == 1) {
        setTimeout(() => {
          const dd = new Date();
          this.fcs.sessiontime.start_time = dd.getTime().toString();
          sessionStorage.setItem('sessionstarttime', dd.getTime().toString());
        }, 1000);
      }
    }));
    this.tooltip_data = this.dss.tooltip_list.filter(obj => obj.screen_identifier == 'FEED_VISIT' || obj.screen_identifier == 'GRAND_ROUND');
  }
  /**
   * check User Ideal State.
   */
  checkUserIdealState(): void {

    this.subscriptions.add(observableTimer(0, 5000)
      .subscribe(() => {
        environment.ideal_state.ideal_state_timer = environment.ideal_state.ideal_state_timer + 5000;
        if (environment.ideal_state.ideal_state_timer >= environment.ideal_state.ideal_state_time) {
          if (environment.ideal_state.is_ideal_state == false && environment.ideal_state.current_page == this.page_from) {
            setTimeout(() => {
              const d = new Date();
              if (sessionStorage.getItem('sessionstarttime') != null) {
                this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
              }
              id = this.feedObject.product_type_id;
              this.fcs.sessiontime.end_time = d.getTime().toString();
              environment.ideal_state.ideal_state_timer = 0;
              environment.ideal_state.is_ideal_state = true;
            }, 500);
          }
        }
      }));
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    const d = new Date();
    const exitData : DETAIL_EXIT =  {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
      entity_code: this.feedId,
      start_time: this.startTime,
      current_screen_name: SCREEN_NAME.FEED_DETAIL,
      end_time: new Date().getTime()
    }
      this.analyticSdk.analyticService.DETAIL_EXIT(exitData);
    if (sessionStorage.getItem('sessionstarttime') != 'null') {
      this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
    }
    this.fcs.sessiontime.end_time = d.getTime().toString();
    environment.ideal_state.current_page = '';
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
    this.showPostedIn = false;
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    if (this.mediaIdx == undefined) {
      this.mediaIdx = 0;
    }
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    if (sessionStorage.getItem('userProfileData') != null) {
      this.userProfileData = (JSON.parse(this.encrypt.decryptAes(this.localStorage.getInSessionStorage('userProfileData'))));
      this.comment_box_obj.profile_pic = this.userProfileData['profile'].profile_pic_path;
      this.userId = this.userProfileData['profile'].custom_id;
    }
    this.getFeedDetail();
  }

  /**
   * get Feed Detail
   */
  getFeedDetail(): void {
    this.startTime = new Date().getTime();
    const entryData: DETAIL_ENTRY = {
      entity_type :  PRODUCT_TYPE_CONSTANT_NAME.FEED,
      entity_code:   this.feedId,
      current_screen_name: SCREEN_NAME.FEED_DETAIL,
      start_time: new Date().getTime(),
      source: this.fcs.currentScreename ? this.fcs.currentScreename : localStorage.getItem('triggerSource')
    }
    this.fcs.currentScreename = SCREEN_NAME.FEED_DETAIL;
    this.analyticSdk.analyticService.DETAIL_ENTRY(entryData);
    this.feed_detail_api_in_process = true;

    this.subscriptions.add(this.gws.getfeedetailNew(this.feedId, this.ecId).subscribe(resData => {
      this.feed_detail_api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.feedObject = data.data['feed'];
          this.productType = data.data['feed'].product_type;
          this.dss.setECDetails(this.feedObject);
          const audioData = this.feedObject.media_list.find(media => media.media_type === this.mediaType.AUDIO);
          if (audioData !== undefined) {
            this.getToken(0);
          }
          this.suggestionObj = { product_type_id: this.feedObject.feed_id, product_type: 1, section: this.dss.suggestion_keys.SUGGESTION_KEY_FEED_DETAIL, offset: 1 };
          this.comment_box_obj.product_type_id = '1';
          this.comment_box_obj.product_id = this.feedObject.feed_id;
          if (this.feedObject.user_profile == null) {
            if (this.feedObject.channel != null) {
              this.channelDetail = { custom_id: 'not_show', chat_id: this.feedObject.channel.channel_id, connection_status: '', is_connect_enable: '', permission: '', profile_pic: this.feedObject.channel.channel_logo, registered_name: this.feedObject.channel.title, specialities: '', 'target_id': this.feedObject.channel.channel_id, 'full_name': this.feedObject.channel.title, 'channel_name': this.feedObject.channel.title, 'tnc_url': this.feedObject.channel.tnc_url, 'target_name': this.feedObject.channel.title, 'publication_logo': this.feedObject.channel.powered_by, 'subscribe_status': this.feedObject.channel.is_subscribed, 'channel_powered': this.feedObject.channel.powered_by_label, 'powered_name': this.feedObject.channel.powered_name };
            }

          }
          if (this.feedObject['feed_comment_list'].length > 0) {
            this.showComment = true;
            this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': this.feedObject['feed_comment_list'], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
          } else {
            this.showComment = false;
            this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': [], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
          }
        } else if (data.status === 0 && data.error.code === STATUS_CODE.ONE_THOUSAND_FIVE) {
          this.error_msg = data.error.msg ?? '';
        }
      }, () => {
        this.feed_detail_api_in_process = false;
      });
    }));
  }

  /**
   * modal feed
   */
  modalfeed(): void {
    this.feedDetailModal = true;
    document.querySelector<HTMLInputElement>('#feed_modal_slide')?.focus();
  }

  /**
   * hide Modal
   */
  hideModal(): void {
    this.feedDetailModal = false;
    this.resetFeedDetailModal.emit(false);
  }

  /**
   * onHidden
   */
  onHidden(): void {
    this.feedDetailModal = false;
    this.resetFeedDetailModal.emit(false);
  }

  /**
   * seeMore
   */
  seeMore(): void {
    this.see_more = true;
  }

  /**
   * seeLess
   */
  seeLess(): void {
    this.see_more = false;
  }

  /**
   * Share Data from comment
   */
  shareCommentCountToParent(process): void {
    if (process == 'add') {
      this.feedObject.total_comments = ++this.feedObject.total_comments;

    } else {
      this.feedObject.total_comments = --this.feedObject.total_comments;
    }
  }

  /**
   * call Like Component
   */
  callLikeComponent(action): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }

    if (action == 'set' && this.feedObject.like_status === 1) {
      return;
    }

    if (action == 'set') {
      this.feed_like_loader = true;
    }
    this.likeObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'callLikeProperty': action };
    this.showLikeListModal = true;
  }

  /**
   * reset like list modal
   */
  resetLikeModalList(val): void {
    this.showLikeListModal = val['reset'];
    const likeAction = val['reaction']['action'];
    if (likeAction == 'set' && this.feedObject['like_status'] != 1) {
      if (likeAction) {
        this.feedObject['like_status'] = 1;
        const likeListObj = [{ 'like_id': 0, 'user_id': 0, 'date_of_updation': 3432, 'date_of_creation': 34321, 'custom_id': this.loginUserCustomeId, 'name': 'You', 'profile_pic_path': this.userProfileData['profile'].profile_pic_path }];
        this.feedObject['like_list'] = likeListObj.concat(this.feedObject['like_list']);
        ++this.feedObject['total_like'];
      }
    }

  }
  /****************************EOF Like Section************************/

  /**
   * reset Like
   */
  resetLike(): void {
    this.feed_like_loader = false;
    this.showLikeListModal = false;
  }

  /**
   * product Bookmark
   */
  productBookmark(): void {
    if (this.feed_bookmark_loader == true) { return; }
    this.feed_bookmark_loader = true;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED, this.feedObject.feed_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null )
    const action = (this.feedObject.is_bookmarked == 0) ? 'add' : 'delete';
    this.subscriptions.add(this.postSer.productBookmark(1, this.feedObject.feed_id, action).subscribe(resData => {



      this.feed_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.feedObject.is_bookmarked = (action == 'add') ? 1 : 0;
          this.dss.feed_detail_action.next(this.feedObject);
        } else if (data['status'] == 0) {
          this.fcs.showError(data['msg'], 'Error');
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_bookmark_loader = false;
      });
    }));
  }

 /**
   * onActive Slide Change
   */
  onActiveSlideChange(event): void {
    this.useractivity = !this.useractivity;
    this.mediaIdx = event.relatedTarget;
  }



  /**
   * set slider cls
   */
  setslidercls(): void {
    const carouselPrev = (document.querySelectorAll<HTMLElement>('.carousel-control-prev'));
    carouselPrev.forEach(el => el?.classList?.add('leftRs', 'cursor-pointer', 'feed-arrow-pos'));
    const carouselNext = (document.querySelectorAll<HTMLElement>('.carousel-control-next'));
    carouselNext.forEach(el => el?.classList?.add('rightRs', 'cursor-pointer', 'feed-arrow-pos'));
    const carouselIndicator = (document.querySelectorAll<HTMLElement>('.carousel-indicators'));
    carouselIndicator.forEach(el => el?.classList?.add('d-block', 'text-right', 'ml-0', 'mt-2', 'mr-3', 'feed-detail-slider'));
    const carouselIndicatorLi = (document.querySelectorAll<HTMLElement>('.carousel-indicators li'));
    carouselIndicatorLi.forEach(el => el?.classList?.add('d-inline-block', 'h-auto', 'border'));
    const carouselIndicatorLiImg = (document.querySelectorAll<HTMLElement>('.carousel-indicators li img'));
    carouselIndicatorLiImg.forEach(el => el?.classList?.add('thumnail-size-feed'));
    const carouselPrevIcon = (document.querySelectorAll<HTMLElement>('.carousel-control-prev-icon'));
    carouselPrevIcon.forEach(el => el?.classList?.add('ic-bg-left', 'text-white', 'ic-ms-l'));
    const carouselNextIcon = (document.querySelectorAll<HTMLElement>('.carousel-control-next-icon'));
    carouselNextIcon.forEach(el => el?.classList?.add('ic-bg-right', 'text-white', 'ic-ms-r'));
    this.keyboard = true;
  }

  /**
   * update Media Selector
   */
  updateMediaSelector(idx): void {
    this.mediaIdx = idx;
    this.useractivity = !this.useractivity;
  }

  /**
   * Poll On Feed
   */
  PollOnFeed(feed_id, option_id, poll_status): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (poll_status != 1) {
      this.subscriptions.add(this.postSer.feedPoll(feed_id, option_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.feedObject.poll = data['data'].poll;
            this.feedObject.poll_status = 1;
            this.dss.feed_detail_action.next(this.feedObject);
          } else if (data['status'] == 0) {
            this.fcs.errorHandeler(data);
            return;
          }
        });
      }));
    }
  }

  /**
   * set style for poll feed
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMyStyles(per, poll_status): any {
    let myStyles;
    if (poll_status === 0) {
      myStyles = {
        'width': +'0%'
      };
    } else {
      myStyles = {
        'width': per + '%'
      };
    }
    return myStyles;
  }

  /**
   * product Share
   */
  productShare(): void {
    const x = [{ share_url: this.feedObject.feed_share_url, share_contentt: this.feedObject.share_content, product_type: 1, product_type_id: this.feedObject.product_type_id }];
    this.fcs.productShare(x, SCREEN_NAME.FEED_DETAIL);
  }

  /**
   * product Like
   */
  productLike(): void {
    if (this.feed_like_loader == true || this.feedObject.like_status == 1) { return; }
    this.feed_like_loader = true;
    const likeData : LIKE  = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.FEED,
      entity_code: this.feedObject.feed_id,
      current_screen_name: SCREEN_NAME.FEED_DETAIL,
      start_time: new Date().getTime(),
      action_on : ACTION_ON.LIKE,
      action_type : ACTION_TYPE.CLICK,
      cta_type : CTA_TYPE.ENGAGEMENT_BAR,  
  }
    this.analyticSdk.analyticService.LIKE(likeData);
    this.subscriptions.add(this.postSer.productLike(1, this.feedObject.feed_id, 'like').subscribe(resData => {
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.feedObject.like_status = 1;
          this.feedObject.total_like = this.feedObject.total_like + 1;
          this.dss.feed_detail_action.next(this.feedObject);
          if (this.dss.isStoryLikeShareEnabled === 1) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key11, this.mls.languageText.stories_tutorial.key12,
            USER_STORY_NUDGE.is_story_first_like_enabled);
            this.dss.isStoryLikeShareEnabled = 0;
          }
        } else if (data['status'] == 0) {
          this.fcs.showError(data['msg'], 'Error');
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_like_loader = false;
      });
    }));
  }

  /**
   * reset Comment
   */
  resetComment(data): void {
    this.feedObject.total_comments = this.feedObject.total_comments + 1;
    this.feedObject.feed_comment_list = this.feedObject.feed_comment_list.unshift(data);
    this.dss.feed_detail_action.next(this.feedObject);
  }

  /**
   * reset Cmt List
   */
  resetCmtList(data): void {
    this.feedObject.feed_comment_list = data;
    this.feedObject.total_comments = this.feedObject.feed_comment_list.length;
    this.dss.feed_detail_action.next(this.feedObject);
  }

  /**
   * go to tagged user
   */
  gototaggeduser(data): void {
    this.fcs.navigateToUserProfie(data.custom_id);
    this.resetFeedDetailModal.emit(false);
  }

  /**
   * Get specialty aligned with feed post.
   */
  getSpecialty(speciality, sendEvent = false): void {
    if (sendEvent) {
      const analyticData : CLICK = {
        entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.feedObject.product_type.toString()],
        entity_code: this.feedObject.product_type_id,
        current_screen_name:  SCREEN_NAME.FEED_DETAIL,
        start_time: new Date().getTime(),
        action_on : ACTION_ON.SPECIALITY_HASTAG,
        action_type : ACTION_TYPE.CLICK,
        cta_type : CTA_TYPE.TEXT,
        rank: null
      }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[this.feedObject.product_type.toString()],this.feedObject.product_type_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null );
    }
    if (speciality?.modalAction) {
      this.feedSpecialty.emit(speciality);
    } else {
      this.feedSpecialty.emit({ speciality: speciality, modalAction: 'close-modal' });
    }
  }
  logSpecailityCLickEvent(): void {

  }

  /**
   * Used to get STS token from API
   */
  getToken(type): void {
    this.subscriptions.add(this.getApiService.getStSToken().subscribe(data => {
      if (data && data['status'] === 1 && data['code'] === 2000 && data['data'] !== undefined && data['data'] !== null) {
        this.SQSCredentials = data['data'];
        if (type === 1) {
          this.receiveSQSInterval(this.lastSQSData);
        }
      }
    }));
  }

  /**
   * Function is used to get interval data to send in SQS.
   */
  receiveSQSInterval(data): void {
    if (data.timespent === 0) {
      return;
    }
    this.lastSQSData = data;
    if (this.SQSCredentials && this.SQSCredentials !== undefined && this.SQSCredentials !== null) {
      this.sqsdataService.SQSEventData.location = {
        latitude: '0',
        longitude: '0',
        local: this.lang,
        time_zone: this.timeZoneOffset
      };

      const d = new Date();
      const linkedData = {};
      const sessionTime = { 'start_time': d.getTime() - data.SQSTimeInterval, 'end_time': d.getTime() };
      this.sqsdataService.sqsVideoLog(Object.assign({}, sessionTime),
        this.mls.googleEventText.feed_detail.key8,
        this.feedObject.product_type,
        this.feedObject.product_type_id,
        this.page_from,
        this.dss.user_profile_data.profile.track_id, data.seekTime, data.timespent, linkedData);

      this.sqsdataService.SQSEventData.session_time = sessionTime;
      const events = { device_info: this.docAnalyticsService.sqsDeviceInfo, event: [this.sqsdataService.SQSEventData] };
      /**
       *  Send message in SQS
       */
      const sqs = new this.dss.awsInstance.SQS({
        region: 'ap-southeast-1',
        apiVersion: '2012-11-05',
        accessKeyId: this.SQSCredentials.sts.Credentials.AccessKeyId,
        secretAccessKey: this.SQSCredentials.sts.Credentials.SecretAccessKey,
        sessionToken: this.SQSCredentials.sts.Credentials.SessionToken
      });
      const params = {
        DelaySeconds: 0,
        MessageBody: JSON.stringify(events),
        QueueUrl: environment.baseUrls.sqsQueueURL
      };
      sqs.sendMessage(params, (err) => {
        if (err) {
          this.getToken(1);
        }
      });
    }
    /**
     * analytics event add on toggle audio
     */
    data.SQSTimeInterval === 0 ? this.playerEvent('audio', true) : this.playerEvent('audio', false);
  }

  /**
   * check connect button is visible or not
   *
   * @readonly
   * @type {boolean}
   * @memberof WebFeedDetailComponent
   */
  get isEditorsChoicePost(): boolean {
    return this.dss.ecProductFeed && this.dss.ecProductFeed.isEcProduct;
  }

  /**
   * Emit user comment.
   */
  emitComment(data: userComment): void {
    this.emitUserComment = data;
  }
  /**
   * event handler for open feed detail
   * @param event
   */
  handleOpenFeedEvent(event: boolean): void {
    this.showPostedIn = event;
    this.isPostedEvent = false;
  }

  /**
   * total count for feed posted in community
   */
  get postedCommunitySize(): number {
    return this.feedObject.mapping_count.community || NUMBERS.ZERO;
  }

  /**
   * remaining count for feed posted in community user not part of
   */
  get remainingCommunity(): number {
    return (this.feedObject.mapping_count.community - this.feedObject.community.length);
  }

  /**
   * remaining count for feed posted in community user not part of text
   */
  get remainingCommunityText(): string {
    const regex = COMMUNITY_REGEX.COUNT;
    let msg = '';
    if (this.feedObject.community.length) {
      msg = this.mls.languageText.community.key146;
    }
    msg += ` actual_count ${this.mls.languageText.community.key145} `;
    if (this.remainingCommunity > NUMBERS.ONE) {
      msg += this.mls.languageText.community.key148;
    } else {
      msg += this.mls.languageText.community.key147;
    }
    return this.fcs.replaceWithActualValue(regex, msg, this.remainingCommunity.toString());
  }

  /**
   * remaining count for feed posted in association text
   */
  get remainingAssociationsText(): string {
    const regex = COMMUNITY_REGEX.COUNT;
    let msg = '';
    if (this.feedObject.user_feed_association_list.length) {
      msg = this.mls.languageText.community.key146;
    }
    msg += ` actual_count ${this.mls.languageText.community.key145} `;
    if (this.remainingAssociation > NUMBERS.ONE) {
      msg += this.mls.languageText.community.key149;
    } else {
      msg += this.mls.languageText.community.key144;
    }
    return this.fcs.replaceWithActualValue(regex, msg, this.remainingAssociation.toString());
  }

  /**
  * total count for feed posted in association
  */
  get postedAssociationSize(): number {
    return this.feedObject.mapping_count.association || NUMBERS.ZERO;
  }
  /**
   * remaining count for feed posted in association
   */
  get remainingAssociation(): number {
    return (this.feedObject.mapping_count.association - this.feedObject.user_feed_association_list.length);
  }

  /**
   * returns privacy type of community
   */
  privacyType(community: GrCommunity): string {
    if (!community?.privacy) {
      return;
    }
    if (community?.privacy === COMMUNITY_PRIVACY.PRIVATE) {
      return this.mls.languageText.community.key67;
    }
    if (community?.privacy === COMMUNITY_PRIVACY.PUBLIC) {
      return this.mls.languageText.community.key66;
    }
  }

  /**
   *
   * @param index returns card CTA text
   * @returns
   */
  getCtaText(community: GrCommunity): string {
    return (community?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL
      ? (community.withdrawRequest || +community?.request?.response === NUMBERS.TWO ? this.mls.languageText.community.key88 : this.mls.languageText.community.key103)
      : this.mls.languageText.community.key72);
  }

  /**
   * returns checks to show join community CTA
   */
  showJoinButton(community: GrCommunity): boolean {
    return community?.privacy === COMMUNITY_PRIVACY.PUBLIC &&
      community?.flags?.show_join_button === NUMBERS.ONE;
  }

  /**
   * Join public community event handler
   * @param community
   */
  joinCommunity(community: GrCommunity): void {
    if (community?.withdrawRequest || +community?.request?.response === NUMBERS.TWO) {
      this.withdrawRequest = {
        openModal: community?.withdrawRequest || +community?.request?.response === NUMBERS.TWO,
        community: community,
        callingFrom: ''
      };
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,community?.da_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.WITHDRAW_REQUEST, null);
      this.withdrawConfirmation(this.withdrawRequest);
    } else {
      community?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL
        ? this.requestToJoinHandler(community)
        : this.joinCommunityHandler(community);
    }
  }

  /**
   * Event handler for sending request to admin to join public community
   */
  requestToJoinHandler(community: GrCommunity): void {
    community.loading = true;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, community?.da_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.COMMUNITY_JOIN_REQUEST, null);
    this.fcs.joinPublicCommunity(community.community_id, NUMBERS.ONE.toString()).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      community.loading = false;
      if (response.status === NUMBERS.ONE && response.code === NUMBERS.TWO_THOUSAND) {
        this.fcs.showSuccess(this.mls.languageText.community.key89, this.mls.languageText.toster.key2);
        community.withdrawRequest = true;
      }
      if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
        community.withdrawRequest = false;
        this.fcs.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
      }
    });
  }

  /**
   * Join public community eventhandler
   */
  joinCommunityHandler(community: GrCommunity): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, community?.da_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.JOIN_COMMUNITY, null);
    community.loading = true;
    this.fcs.joinPublicCommunity(community.community_id).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      community.loading = false;
      if (response.status === NUMBERS.ONE) {
        this.fcs.showSuccess(this.mls.languageText.toster.key2, this.mls.languageText.toster.key2);
        this.fcs.navigateToCommunityDetailAndReload(community.community_id);
      } else {
        this.fcs.errorHandeler(response);
      }
    },
      (error) => {
        community.loading = false;
        this.fcs.errorHandeler(error);
      });
  }

  /**
   * Handler to navigate to community details
   * @param community_id
   */
  navigateToDetail(community_id: string): void {
    this.fcs.navigateToCommunityDetailAndReload(community_id);
  }

  /**
   * getter for postedIn details
   */
  get postedIn(): PostedIn {
    if (!this.feedObject) {
      return null;
    }
    return this.fcs.getPostedInDetail(this.feedObject);
  }

  repost(): void {
    if (this.feedObject.repost_info !== null && this.feedObject.repost_info?.is_available === NUMBERS.ZERO) {
      this.fcs.showError('', this.mls.languageText.feed_detail.key15);
      return;
    } else if (this.feedObject.repost_info !== null && this.feedObject.repost_content?.data?.channel !== null && this.feedObject.repost_content?.data?.channel?.content_visibility?.display !== NUMBERS.ONE) {
      this.fcs.showError('', this.mls.languageText.feed_card_screen.key21);
      return;
    } else if (this.feedObject.repost_content === null && this.fcs?.device_detail?.is_desktop != true) {
      this.dss.repostProductId = this.feedObject.product_type_id;
      this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
      this.dss.webinarRepostObject = this.feedObject;
      if (this.feedObject.user_profile && this.dss.user_profile_data?.profile?.permission === 'all') {
        this.dss.tagedUser.push(this.feedObject.user_profile);
        this.dss.posting_data.screen1.tag_to.push(this.feedObject.user_profile);
      }
    } else if (this.fcs?.device_detail?.is_desktop !== true) {
      this.dss.repostProductId = this.feedObject.repost_content.product_id;
      this.dss.repostProductType = this.feedObject.repost_content.product_type;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
      this.dss.webinarRepostObject = this.feedObject.repost_content.data;
      if (this.feedObject.repost_content.product_type === NUMBERS.ONE && this.feedObject.repost_content.data.user_profile && this.dss.user_profile_data?.profile?.permission === 'all') {
        this.dss.tagedUser.push(this.feedObject.repost_content.data.user_profile);
        this.dss.posting_data.screen1.tag_to.push(this.feedObject.repost_content.data.user_profile);
      }
    } else {
      this.emitRepostData.emit(true);
    }
  }
  /**
   * generate repost meta
   */
  generateMeta(): void{
    /**
     * Check re-post popver for community.
     */
    this.fcs.checkRepostPopOver(this.feedObject?.topic_community_flag,this.feedObject?.channel?.community_id, this.feedObject?.hl?.tcf);

    this.isMetaGenerated = true;
    this.analyticSdk.analyticService.CLICK( PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedId.product_type_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.REPOST, null );
  }
  /**
   * repost as story
   */
  repostFeed(event): void {
    if (event === REPOST_TYPE_ITEM.REPOST_ON_FEED) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedId,
        SCREEN_NAME.FEED_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_FEED, null);
      this.repost();
    }
    else if (event === REPOST_TYPE_ITEM.REPOST_AS_STORY) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedId,
        SCREEN_NAME.FEED_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null);
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.fcs.assignAssociation('');
        return;
      }
      this.repostAsStory();
    }
  }
  /**
   * repost wbinar as story
   */
  repostAsStory(): void {
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
    this.dss.user_story_productTypeId = this.feedObject.product_type_id;
    this.dss.create_Story_productData.next(this.feedObject);
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.create_Story.next(true);
    this.hideModal();
  }
  /**
   * create story through nudge
   */
  createStoryThroughNudge(storyNudgeHeading, storyNudgeDisc, nudgeType ): void {
    this.dss.storyNudgeIcon = 'assets/images/webinar-nudge.png';
    this.dss.storyNudgeHeading = storyNudgeHeading;
    this.dss.storyNudgeDisc = storyNudgeDisc,
    this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key16;
    this.dss.story_nudge_type = nudgeType;
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
    this.dss.user_story_productTypeId = this.feedObject.product_type_id;
    this.dss.create_Story_productData.next(this.feedObject);
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.userStoryNudge.next(true);
  }

  /**
   * close posting meta
   */
  closeMeta(event): void{
    this.fcs.isShowFeedRepost = true;
    this.isMetaGenerated = false;
  }

  /**
   * event handler for community detail navigation
   * @param community_id
   */
  handleCommunityDetailEvent(community_id: string): void {
    this.fcs.navigateToCommunityDetailAndReload(community_id);
  }

  /**
   * Confirmation withdraw request.
   */
  withdrawConfirmation(communityConfirmation: CommunityConfirmation): void {
    if (!this.confirmationText) {
      this.setConfirmationText();
      this.requestWithdrawStatus();
    }
    this.confirmedCommunity = communityConfirmation;
    this.confirmationModal = communityConfirmation.openModal;
  }

  /**
   * sets confirmation message for withdraw request
   */
  setConfirmationText(): void {
    this.confirmationText = {
      bodyText: this.mls.languageText.community.key91,
      headingText: this.mls.languageText.community.key92,
      allowButtonText: this.mls.languageText.community.key93,
      cancelButtonText: this.mls.languageText.community.key94
    };
  }

  /**
   * Reset confirm modal.
   */
  resetConfirmModal(): void {
    this.confirmationModal = false;
  }
  /**
 * Allow withdraw request.
 */
  allowAction(isAllow: boolean): void {
    if (isAllow) {
      this.resetConfirmModal();
    }
  }
  /**
   * Withdraw actions to get on card CTA click.
   */
  requestWithdrawStatus(): void {
    this.fcs.getWithdrawStatus.pipe(
      takeUntil(this.notifier$))
      .subscribe(() => {
        this.withdrawRequest.community.loading = true;
        if (this.withdrawRequest.community) {
          this.fcs.joinPublicCommunity(
            this.withdrawRequest.community.community_id,
            this.numbers.ZERO.toString()).pipe(
              takeUntil(this.notifier$)
            ).subscribe(response => {
              this.withdrawRequest.community.loading = false;
              if (response.status === this.numbers.ONE && response.code === this.numbers.TWO_THOUSAND) {
                this.withdrawRequest.community.request.response = this.numbers.ZERO;
                this.withdrawRequest.community.request.type = '';
                this.fcs.showSuccess(this.mls.languageText.community.key90, this.mls.languageText.toster.key2);
                this.withdrawRequest.community.withdrawRequest = false;
              }
              if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
                this.fcs.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
              }
            },
              (error) => {
                this.withdrawRequest.community.loading = false;
                this.fcs.errorHandeler(error);
              });
        }
      });
  }

  /**
   * analytics event on wrt given parameters
   * @param contentType 
   * @param isPlay 
   */
  playerEvent(contentType: string, isPlay: boolean): void {
    /**
     * analytics on clicking swipe button
     */
    const action_on = (contentType === 'video') 
    ? (isPlay ? ACTION_ON.VIDEO_PLAY : ACTION_ON.VIDEO_PAUSE) 
    : (isPlay ? ACTION_ON.AUDIO_PLAY : ACTION_ON.AUDIO_PAUSE);
    this.analyticSdk.analyticService.CLICK( PRODUCT_TYPE_CONSTANT_NAME.FEED,this.feedObject.product_type_id, SCREEN_NAME.FEED_DETAIL, CTA_TYPE.MEDIA, ACTION_TYPE.CLICK, action_on, null );
  }
}
